import { IActionCreatorAsync } from 'core/actions/Actions.interfaces';
import { IUser } from 'reducers/Reducers.interfaces';

export interface IUserOverview {
    user: IUser
    deleteUser: IActionCreatorAsync
    profile?: IUser
    fetchUserById: IActionCreatorAsync
    initLocalization: IActionCreatorAsync
    editUser: IActionCreatorAsync
    resendVerificationLink: IActionCreatorAsync
    resetMfaLink: IActionCreatorAsync
    updateDetails: () => void
}

export enum UserUpdateType {
    UserDetails = 'updateUserDetails',
    AccountAccess = 'updateAccountAccess',
    UserCredentials = 'resetUserCredentials',
    UserOverview = 'userOverview',
    UserServices = 'updateUserServices',
    ApiToken = 'createApiToken',
    UpdateApiToken = 'updateApiToken',
    CreateCertificate = 'createCertificate',
    UploadCertificate = 'uploadCertificate'
}

export enum ResetUserCredentialsType {
    SendUsername = 'sendUsername',
    ResetPassword = 'resetPassword',
    ResetTwoFactor = 'resetTwoFactor'
}